<template>
  <component
    :is="tagName || 'div'"
    :class="[classes, pointClass]"
    @click="passMethod('click')"
  >
    <slot></slot>
  </component>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['tagName'],
};
</script>
